import React from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import ImageSlider from '../components/ImageSlider';

const Access = () => {

	const history = useHistory();

	const goDashboard = () => {
		history.push('/');
	}

	return (
		<div className="pages-body flex bg-white">
			<div className="img-left fadeinleft animation-duration-500 hidden sm:flex lg:w-8 md:w-6 bg-gray-100 justify-content-center align-items-center">
				<ImageSlider
				/>
			</div>

			<div className="surface-0 m-auto fadeinright animation-duration-500 align-self-center m-auto bg-white lg:w-4 md:w-6 w-11" style={{ background: 'green !important' }}>
				<div className="pages-panel  flex flex-column">
					<div className="pages-header px-3 py-1 border-2">
						<h2 className='text-black-alpha-80'>ACCESS DENIED</h2>
					</div>
					<div className="mt-3 px-6">
						<img src="assets/layout/images/pages/error.png" alt="" />
					</div>
					<div className="pages-detail pb-6">Requested resource is not available.</div>
					<Button type="button" onClick={goDashboard} label="GO BACK TO DASHBOARD" className="p-button-text"></Button>
				</div>
			</div>
		</div>
	)

}

export default Access;
